// extracted by mini-css-extract-plugin
export default {"header":"header__3ax1h","logo":"logo__3Ki4n","active":"active__2XB2z"};